import { createSlice } from "@reduxjs/toolkit";


const featureMenuSlice = createSlice({
    name: "featureMenu",
    initialState: {
        data: null,
    },
    reducers: {
        setFeatureMenu: (state, action) => {
            state.data = action.payload
        }
    },
});

export const { setFeatureMenu } = featureMenuSlice.actions;
export default featureMenuSlice.reducer;
